import { Box, Button, Divider, Stack } from "@mui/material";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import React, { useState } from "react";
import Ukeylogo from "../../../assets/LOGISTICSLogo2.png";
import DashboardLogo from "../../../assets/Layout/post.png";
import UserLogo from "../../../assets/Layout/user.png";
import VehicleLogo from "../../../assets/Layout/fluent_vehicle-truck-cube-24-regular.png";
import DeviceLogo from "../../../assets/Layout/ion_hardware-chip-outline.png";
import DriverLogo from "../../../assets/Layout/healthicons_truck-driver-outline.png";
import TripLogo from "../../../assets/Layout/Vector.png";
import MaintenanceLogo from "../../../assets/Layout/pajamas_issue-type-maintenance.png";
import FuelLogo from "../../../assets/Layout/lucide_fuel.png";
import SettingLogo from "../../../assets/Layout/settings.png";
import LogoutLogo from "../../../assets/Layout/Left_icon.png";
import { useAuth } from "../../../Authentication/AuthContext";
import {
    lineStyle,
    listItemIconStyle,
    listItemStyles,
    listStyle,
    logoutButtonContainer,
} from "../../UI/Layout";
import { useNavigate } from "react-router-dom";

function Sidebar2() {
    const { userRole } = useAuth();

    const navigate = useNavigate();
    const [selectedItem, setSelectedItem] = useState(0);

    const handleListItemClick = (index, route) => {
        setSelectedItem(index);
        navigate(route);
    };

    const listItems = [
        { text: "Dashboard", icon: DashboardLogo, route: "dashboardmain" },
        { text: "User Management", icon: UserLogo, route: "user-management" },
        {
            text: "Vehicle Management",
            icon: VehicleLogo,
            route: "vehicle-management",
        },
        { text: "Device Management", icon: DeviceLogo, route: "device-management" },
        { text: "Driver Management", icon: DriverLogo, route: "driver-management" },
        { text: "Trip Management", icon: TripLogo, route: "trip-management" },
        {
            text: "Maintenance Scheduling",
            icon: MaintenanceLogo,
            route: "maintenance-scheduling",
        },
        { text: "Fuel Management", icon: FuelLogo, route: "fuel-management" },
        { text: "Setting", icon: SettingLogo, route: "setting" },
    ];

    const customerlistitems = [
        { text: "All Users", icon: DashboardLogo, },
        // {
        //     text: "Maintenance Scheduling",
        //     icon: MaintenanceLogo,
        //     route: "maintenance-scheduling",
        // },
        // {
        //     text: "Fuel Management",
        //     icon: FuelLogo,
        //     // route: "customer-fuel-management",
        //     route: "fuel-management",
        // },
        // { text: "Setting", icon: SettingLogo, route: "customer-setting" },
    ];

    // Conditionally set the list items based on the userRole
    const listToRender = customerlistitems;

    const handleLogout = () => {
        localStorage.clear();
        navigate("/login")
    }

    return (
        <Box
            flex={2}
            display={{ xs: "none", lg: "flex" }}
            height={"100vh"}
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
        >
            <Box
                sx={{
                    width: "16.5vw",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    zIndex: 1000,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        width: "96%",
                        height: "98vh",
                        minWidth: "220px",
                        minHeight: "510px",
                        borderRadius: "10px",
                        backgroundColor: "#15294E",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                    mt={2}
                >
                    <Box sx={listStyle} mt={"0.2em"}>
                        <img
                            src={Ukeylogo}
                            alt="logo"
                            style={{
                                height: "auto",
                                maxWidth: "70%",
                                maxHeight: "70%",
                                objectFit: "contain",
                                paddingTop: "1rem",
                                paddingBottom: "1rem",
                            }}
                        />
                        <Divider sx={{ backgroundColor: "#F38712" }} />
                        <List>
                            {listToRender.map((item, index) => (
                                <ListItem
                                    button
                                    key={item.text}
                                    onClick={() => handleListItemClick(index, item.route)}
                                    sx={{
                                        ...listItemStyles,
                                        backgroundColor:
                                            selectedItem === index ? "#F38712" : "transparent",
                                        "&:hover": {
                                            backgroundColor:
                                                selectedItem === index ? "#F38712" : "#3D4149",
                                        },
                                    }}
                                >
                                    <ListItemIcon sx={listItemIconStyle}>
                                        <img
                                            src={item.icon}
                                            alt={item.text}
                                            style={{
                                                width: "15px",
                                                height: "15px",
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.text}
                                        primaryTypographyProps={{
                                            fontWeight: 500,
                                            fontSize: { xl: "0.99rem", lg: "0.8rem", md: "0.5rem" },
                                            fontFamily: "Poppins",
                                            display: { xs: "block", lg: "block" },
                                            noWrap: false,
                                        }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Box>

                    <Stack sx={logoutButtonContainer}>
                        <Box sx={lineStyle} />
                        <Button
                            variant="contained"
                            fullWidth
                            startIcon={
                                <img
                                    src={LogoutLogo}
                                    alt="dashboard"
                                    width="15px"
                                    height={"auto"}
                                />
                            }
                            sx={{
                                width: "80%",
                                height: { xl: "3rem", lg: "2.3rem" },
                                fontSize: "1rem",
                                backgroundColor: "white",
                                marginBottom: "2rem",
                                color: "black",
                                "&:hover": {
                                    backgroundColor: "lightgray",
                                },
                            }}
                            onClick={handleLogout}
                        >
                            Logout
                        </Button>
                    </Stack>
                </Box>
            </Box>
        </Box>
    );
}

export default Sidebar2;
